import { Component, OnInit } from "@angular/core";
import { NgbCalendar, NgbDatepickerConfig } from "@ng-bootstrap/ng-bootstrap";
import { Utils } from "src/app/common/utils";
import { UsrCred } from "src/app/models/usrcred";

const PATIENT_PROFILE = {
  icon: "fa-eye patient-icon",
  title: "Patient Profile",
  create_url: "/profile/patient",
  edit_url: "/profile/search/patient",
  delete_url: "/profile/delete-patient",
};
const DOCTOR_PROFILE = {
  icon: "fa-user doctor-icon",
  title: "Doctor Profile",
  create_url: "/profile/doctor",
  edit_url: "/profile/search/physicians",
  delete_url: "/profile/delete-doctor",
};
const FRONT_DESK_PROFILE = {
  icon: "fa-usd front-desk-icon",
  title: "Front Desk Profile",
  create_url: "/profile/fdesk-profile",
  edit_url: "/profile/search/user",
  delete_url: "/profile/delete-fdesk-profile",
};

@Component({
  selector: 'app-profiles-dash',
  templateUrl: './profiles-dash.component.html',
  styleUrls: ['./profiles-dash.component.css']
})
export class ProfilesDashComponent implements OnInit {

  user = new UsrCred();
  role: string;
  role_based_profiles = {
    [Utils.USER_TYPE.front_desk]: [PATIENT_PROFILE],
    [Utils.USER_TYPE.physician]: [FRONT_DESK_PROFILE],
    [Utils.USER_TYPE.admin]: [PATIENT_PROFILE, DOCTOR_PROFILE, FRONT_DESK_PROFILE],
  };
  organisation: any;

  constructor(config: NgbDatepickerConfig, calendar: NgbCalendar, private utils: Utils) { }

  ngOnInit() {
    let roles = JSON.parse(localStorage.getItem("LogUsrTyp"));
    if (this.utils.checkRoleType(Utils.USER_TYPE.admin, roles)) {
      this.role = Utils.USER_TYPE.admin;
    } else if (this.utils.checkRoleType(Utils.USER_TYPE.physician, roles)) {
      this.role = Utils.USER_TYPE.physician;
    } else if (this.utils.checkRoleType(Utils.USER_TYPE.front_desk, roles)) {
      this.role = Utils.USER_TYPE.front_desk;
    }
    console.log("From Login", this.role);
    this.organisation = localStorage.getItem("orgcode")
  }

}